<template>
  <div class="lection-list">
    <div class="header">
      <span class="title">一級分類：</span>
      <a-select defaultValue="lucy" style="width: 120px;margin-right:20px;" v-model="oneCla" @change="oneChange" placeholder="請選擇">
        <a-select-option v-for="item in oneList" :key="item.id" :value="item.id">{{ item.desc }}</a-select-option>
      </a-select>
      <span class="title" v-if="oneCla !== '000'">二級分類：</span>
      <a-select v-if="oneCla !== '000'" defaultValue="lucy" style="width: 120px" v-model="scriptureTypeId" placeholder="請選擇">
        <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{ item.desc }}</a-select-option>
      </a-select>
      <span style="margin-left:20px;" class="title">典籍名稱：</span>
      <a-input v-model="title" style="width:200px;" placeholder="請輸入典籍標題"></a-input>
      <a-button type="primary" size="small" style="margin-left:20px;" @click="search">搜索</a-button>
    </div>
    <a-table
        :dataSource="list"
        rowKey="id"
        :loading="loading"
        :pagination="false">
      <a-table-column
          title="典籍名稱"
          align="center"
          dataIndex="title">

      </a-table-column>
      <a-table-column
          title="典籍分類"
          align="center"
          dataIndex="scriptureTypeDesc">

      </a-table-column>
      <a-table-column
          align="center"
          title="上傳時間">
        <template slot-scope="row,item,index">
          {{ item.addTime | trans-date }}
        </template>
      </a-table-column>
      <a-table-column
          title="典籍ID"
          align="center"
          dataIndex="id">
      </a-table-column>
      <a-table-column
          align="center"
          title="操作">
        <template slot-scope="row,item,index">
          <a-button style="margin-right:10px;" @click="del(item)" size="small">刪除</a-button>
          <a-button @click="edit(item)" size="small">編輯</a-button>
        </template>
      </a-table-column>
    </a-table>
    <a-pagination :defaultPageSize="10" :defaultCurrent="1" :total="total" @change="currentChange"/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      typeList: [],
      para: {
        pageIndex: 1,
        pageSize: 10,

      },
      scriptureTypeId: '000',
      title: '',
      total: 0,
      oneCla: '000',
      oneList: []
    }
  },
  methods: {
    getOneList(){
      this.$http({
        method: 'get',
        url: '/manager/category/selectAll',
      }).then(res=>{
        this.oneList = res.data;
        this.oneList .unshift({
          addTime: 1643548616168,
          desc: "全部",
          id: '000',
        })
        this.getClaList();
      })
    },
    oneChange(val){
      this.oneCLa = val;
      this.scriptureTypeId = '000'
      this.getClaList()
    },
    getClaList() {
      let self = this;
      let url;
      if(this.oneCla !== '000'){
        url = '/manager/type/scripture/list?id=' + this.oneCla
      }else{
        // url = '/manager/type/scripture/list';
        return false;
      }
      this.$http({
        method: 'get',
        url: url,
      }).then(function (res) {
        if (res.data && res.data.length) {
          self.typeList = res.data;
        } else {
          self.typeList = []
        }
        self.typeList.unshift({id: '000', desc: '全部'})
      }).catch(err => {
      })
    },
    search() {
      if (this.scriptureTypeId === '000') {
        delete this.para.scriptureTypeId;
      } else {
        this.para.scriptureTypeId = this.scriptureTypeId;
      }
      if (this.title === '') {
        delete this.para.title
      } else {
        this.para.title = this.title;
      }
      this.getList();
    },
    getList(id) {
      let self = this;
      this.loading = true;
      let data = JSON.parse(JSON.stringify(self.para))
      if(this.scriptureTypeId !== '000'){
        data.scriptureTypeId = this.scriptureTypeId
      }
      this.$http({
        method: 'post',
        url: '/manager/scripture/list',
        data: data
      }).then(function (res) {
        self.loading = false;
        if (res.data && res.data.list && res.data.list.length) {
          self.list = res.data.list;
          self.total = res.data.totalRows
        } else {
          self.list = []
          self.total = 0
        }
      }).catch(err => {
      })
    },
    del(item) {
      ///manager/scripture/delete
      let self = this;
      this.$Confirm({
        title: '確定刪除嗎？',
        onOk() {
          self.$http({
            method: 'post',
            url: '/manager/scripture/delete',
            data: {
              id: item.id
            }
          }).then(function (res) {
            self.$Message.success('操作成功')
            self.getList()
          }).catch(err => {
          })
        },
        onCancel() {
        }
      })
    },
    edit(item) {
      this.$router.push({name: 'addLection', query: {id: item.id}})
    },
    currentChange(val) {
      console.log(val)
      this.para.pageIndex = val;
      this.getList();
    }
  },
  created() {
    this.getOneList()
    let self = this;
    this.loading = true;
    this.getList();
    this.$emit('breadcrumbChange', ['典籍管理', '典籍列表'])
  },
}
</script>
<style lang="less">
div.lection-list {
  div.header {
    text-align: left;
    margin-bottom: 20px;
  }
}
</style>